module.exports = __webpack_public_path__ + "static/lift-8bce1718ec00e5f0099604c51cdb8c8b.png";